/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { type FC } from 'react';

import { type CommonexcludeType } from '@coze-arch/bot-semi/Form';
import { type BotTableRWMode } from '@coze-arch/bot-api/memory';
import { type CommonFieldProps, withField } from '@coze-arch/coze-design';
export interface DatabaseModeSelectProps {
  disabled?: boolean;
  type?: 'button' | 'select';
  value?: BotTableRWMode;
  options?: BotTableRWMode[];
  onChange?: (value: BotTableRWMode) => void;
}

export const DatabaseModeSelect: FC<DatabaseModeSelectProps> = () => <></>;

export const FormDatabaseModeSelect: React.FunctionComponent<
  CommonFieldProps & Omit<DatabaseModeSelectProps, keyof CommonexcludeType>
> = withField(DatabaseModeSelect, {
  valueKey: 'value',
  onKeyChangeFnName: 'onChange',
});
